<template>
  <div>
    <v-icon
      class="rotated-icon"
      :class="{ 'rotate-icon': rotate }"
      v-if="batteryLevel >= 90"
      style="color: #06cf9c"
      >mdi-battery</v-icon
    >
    <v-icon
      class="rotated-icon"
      :class="{ 'rotate-icon': rotate }"
      v-else-if="batteryLevel >= 80"
      style="color: #54a7e2"
      >mdi-battery-80</v-icon
    >
    <v-icon
      class="rotated-icon"
      :class="{ 'rotate-icon': rotate }"
      v-else-if="batteryLevel >= 60"
      style="color: #ff8423"
      >mdi-battery-60</v-icon
    >
    <v-icon
      class="rotated-icon"
      :class="{ 'rotate-icon': rotate }"
      v-else-if="batteryLevel >= 40"
      style="color: #f2605f"
      >mdi-battery-40</v-icon
    >
    <v-icon class="rotated-icon" :class="{ 'rotate-icon': rotate }" v-else style="color: #b60505"
      >mdi-battery-20</v-icon
    >
  </div>
</template>

<script>
export default {
  name: 'BatteryIcons',
  props: {
    batteryLevel: Number,
    rotate: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // console.log(this.batteryLevel)
  }
}
</script>

<style>
.rotate-icon {
  transform: rotate(90deg);
}
</style>
